module.exports = __webpack_public_path__ + "static/img/awesome-shop_256.5853302.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/awesome-shop_256.png
// module id = e3sC
// module chunks = 0